import { useParams } from "react-router-dom";
import { useGetLoungeRequestQuery } from "../lounge.service";
import { LoungeInfo } from "../components/lounge";
import PageLoading from "src/components/pageLoading";

export const LoungeRequest = () => {
  const { id } = useParams<{ id: string }>();
  const { data, isSuccess } = useGetLoungeRequestQuery(id as string, { skip: !id });
  return isSuccess ? <LoungeInfo data={data} /> : <PageLoading />;
};
